import FingerprintJS from '@phonepe/fingerprintjs';

import { setCookie, getCookie } from '@manage-cards/utils/helpers';
import { Global } from '@manage-cards/constants';

// Initialize an agent at application startup.
// By default it will load all the tests, but if you want your bundle to be smaller,
// you can reduce some of the WebGL tests,
// by providing this flag {webGLTestMode: 0-4},
// 0 => less tests => less size => less execution time => less accuracy
// 3 => all tests  => max size  => high execution time => max accuracy
const fpPromise = FingerprintJS.load();

export const generateBrowserFingerprint = () =>
	new Promise((resolve, reject) => {
		fpPromise
			.then((fp) => fp.get())
			.then((result) => {
				const { visitorId } = result;
				const cookieValue = `mcp_${visitorId}`;
				setCookie(Global.FINGERPRINT_COOKIE, cookieValue, {
					expires: {
						days: 365,
					},
				});
				resolve(cookieValue);
			})
			.catch((error) => {
				reject(new Error(error?.message));
			});
	});

export const getFingerprintCookie = () => getCookie(Global.FINGERPRINT_COOKIE);
